<template>
  <confirm-dialog-template
    v-model="isShownContent"
    title="unsafe.deal.info.title"
    @submit="handleSubmit"
    @cancel="handleCancel"
  >
    <p :class="$style.text">{{ $t('unsafe.deal.info.message') }}</p>
  </confirm-dialog-template>
</template>

<script>
import ConfirmDialogTemplate from 'templates/ConfirmDialogTemplate';

// @TODO: вынести в dialogMixin весь код управления модальным окном
export default {
  name: 'UnsafeDealInfoDialog',
  components: {
    ConfirmDialogTemplate,
  },
  props: {
    value: Boolean,
  },
  data() {
    return {
      isShownContent: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.isShownContent = val;
      },
    },
    isShownContent: {
      handler(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    handleSubmit() {
      this.$emit('submit');

      this.$nextTick(() => {
        this.isShownContent = false;
      });
    },
    handleCancel() {
      this.isShownContent = false;
    },
  },
};
</script>

<style lang="sass" module>
  .text
    opacity: .75
</style>
